const { default: shopifyApi } = require("./jamfreeShopify");

export default {
    newShopifyCustomer:(data) => {return shopifyApi.newCustomer(data)}
}